export default __webpack_public_path__ + "static/media/a4-printer.32c40faf.svg";